import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import "./PdfPage.css";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";
import COmpBiDirTest from "./FaultSecondPageChartsBidirRender_Bus";

// export default function FaultFirstPart(props) {
const FaultFirstPart = forwardRef((props, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [ECUData, setECUData] = useState({});
  const [TempDataBCS1, setTempDataBCS1] = useState([]);
  const [dataMainBCS1, setDataMainBCS1] = useState([]);
  const [toCalculateFaultBCS1, setToCalculateFaultBCS1] = useState(0);
  const [single_nameBCS1, setsingle_nameBCS1] = useState([]);
  const [LineContainerBodyBD, setCssLineCont] = useState({ height: "200px" });
  const [TempDataBCS2, setTempDataBCS2] = useState([]);
  const [dataMainBCS2, setDataMainBCS2] = useState([]);
  const [toCalculateFaultBCS2, setToCalculateFaultBCS2] = useState(0);
  const [single_nameBCS2, setsingle_nameBCS2] = useState([]);
  const [TempDataMCU, setTempDataMCU] = useState([]);
  const [dataMainMCU, setDataMainMCU] = useState([]);
  const [toCalculateFaultMCU, setToCalculateFaultMCU] = useState(0);
  const [single_nameMCU, setsingle_nameMCU] = useState([]);
  const [TempDataVCU, setTempDataVCU] = useState([]);
  const [dataMainVCU, setDataMainVCU] = useState([]);
  const [toCalculateFaultVCU, setToCalculateFaultVCU] = useState(0);
  const [single_nameVCU, setsingle_nameVCU] = useState([]);
  const [bms_duration_one, setBms_duration_one] = useState(0);
  const [bms_duration_two, setBms_duration_two] = useState(0);
  const [bms_duration_three, setBms_duration_three] = useState(0);
  const [bms_duration_four, setBms_duration_four] = useState(0);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/faultanalysis_bus",
        body: { filterdata: gloablfilter },
      },
      ecuFaultResponse
    );
    // fetchData({ url: API_URL_MAIN + "pdf_bus/vehicleLevalBusFault", body: { filterdata: gloablfilter, defaultNav: "BCS-1"}}, responceBarData);
  }, [gloablfilter]);

  useEffect(() => {
    // fetchData({ url: API_URL_MAIN + "pdf_bus/faultanalysis_bus", body: { filterdata: gloablfilter }}, ecuFaultResponse);
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/vehicleLevalBusFault",
        body: { filterdata: gloablfilter, defaultNav: "BCS-1" },
      },
      responceBarData
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/vehicleLevalBusFault",
        body: { filterdata: gloablfilter, defaultNav: "BCS-2" },
      },
      responceBarData
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/vehicleLevalBusFault",
        body: { filterdata: gloablfilter, defaultNav: "MCU" },
      },
      responceBarData
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/vehicleLevalBusFault",
        body: { filterdata: gloablfilter, defaultNav: "VCU" },
      },
      responceBarData
    );
  }, [gloablfilter, ECUData]);

  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      ECUData,
      TempDataBCS1,
      dataMainBCS1,
      toCalculateFaultBCS1,
      single_nameBCS1,
      TempDataBCS2,
      dataMainBCS2,
      toCalculateFaultBCS2,
      TempDataMCU,
      dataMainMCU,
      toCalculateFaultMCU,
      TempDataVCU,
      dataMainVCU,
      toCalculateFaultVCU,
      LineContainerBodyBD,
      bms_duration_one,
      bms_duration_two,
      bms_duration_three,
      bms_duration_four,
    }),
  }));

  const ecuFaultResponse = (data) => {
    const ecuDict = {};
    data.forEach((item) => {
      const ecu = item.key.ECU;
      const vehicleCount = item.vehicle_count.value;
      ecuDict[ecu] = vehicleCount;
    });
    setECUData(ecuDict);
  };

  const responceBarData = (data) => {
    // setTempData(data)
    if (data.defaultNav === "BCS-1") {
      // setTempDataBCS1([]);
      // setDataMainBCS1([]);
      deno(data);
    } else if (data.defaultNav === "BCS-2") {
      // setTempDataBCS2([]);
      // setDataMainBCS2([]);
      deno(data);
    } else if (data.defaultNav === "MCU") {
      // setTempDataMCU([]);
      // setDataMainMCU([]);
      deno(data);
    } else if (data.defaultNav === "VCU") {
      // setTempDataVCU([]);
      // setDataMainVCU([]);
      deno(data);
    }
  };

  const deno = async (data) => {
    if (data.defaultNav !== null && data.defaultNav === "BCS-1") {
      //   if (ECUData.hasOwnProperty(defaultNav)) {
      await setTempDataBCS1(data.result);
      await setToCalculateFaultBCS1(ECUData[data.defaultNav]);
      //   }
    } else if (data.defaultNav !== null && data.defaultNav === "BCS-2") {
      await setTempDataBCS2(data.result);
      await setToCalculateFaultBCS2(ECUData[data.defaultNav]);
    } else if (data.defaultNav !== null && data.defaultNav === "MCU") {
      await setTempDataMCU(data.result);
      await setToCalculateFaultMCU(ECUData[data.defaultNav]);
    } else if (data.defaultNav !== null && data.defaultNav === "VCU") {
      await setTempDataVCU(data.result);
      await setToCalculateFaultVCU(ECUData[data.defaultNav]);
    }
  };

  useEffect(() => {
    if (toCalculateFaultBCS1 !== 0) {
      const data = TempDataBCS1;
      let dataArray = [];
      let maleAdd = 0;
      let femaleAdd = toCalculateFaultBCS1;
      data.forEach((obj1, index) => {
        maleAdd += obj1.duration.value;
      });
      setBms_duration_one(maleAdd);
      let single_name_array = [];
      data.forEach((obj1, index) => {
        let male = (obj1.duration.value / maleAdd) * 100;
        let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
        dataArray.push({
          age: obj1.key.spnname.toUpperCase(),
          male: -male,
          female: female,
          orgLevalMale: obj1.duration.value.toFixed(0).toString(),
          orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
          signal_nm: obj1.key.spnname,
          signal_desc: obj1.key.Description,
          signal_val: obj1.key.spnvalue.toString(),
        });
        single_name_array.push(obj1.key.spnname);
      });
      //   setsingle_nameBCS1(single_name_array);
      for (let i = 0; i < dataArray.length; i++) {
        let count = 0;
        for (let j = i + 1; j < dataArray.length; j++) {
          if (dataArray[i].age === dataArray[j].age) {
            dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
            count = 1;
          }
        }
        if (count) {
          dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
        }
      }
      dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
      setDataMainBCS1(dataArray);
    }

    if (toCalculateFaultBCS2 !== 0) {
      const data = TempDataBCS2;
      let dataArray = [];
      let maleAdd = 0;
      let femaleAdd = toCalculateFaultBCS2;
      data.forEach((obj1, index) => {
        maleAdd += obj1.duration.value;
      });
      setBms_duration_two(maleAdd);
      let single_name_array = [];
      data.forEach((obj1, index) => {
        let male = (obj1.duration.value / maleAdd) * 100;
        let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
        dataArray.push({
          age: obj1.key.spnname.toUpperCase(),
          male: -male,
          female: female,
          orgLevalMale: obj1.duration.value.toFixed(0).toString(),
          orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
          signal_nm: obj1.key.spnname,
          signal_desc: obj1.key.Description,
          signal_val: obj1.key.spnvalue.toString(),
        });
        single_name_array.push(obj1.key.spnname);
      });
      //   setsingle_nameBCS1(single_name_array);
      for (let i = 0; i < dataArray.length; i++) {
        let count = 0;
        for (let j = i + 1; j < dataArray.length; j++) {
          if (dataArray[i].age === dataArray[j].age) {
            dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
            count = 1;
          }
        }
        if (count) {
          dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
        }
      }
      dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
      setDataMainBCS2(dataArray);
    }

    if (toCalculateFaultMCU !== 0) {
      const data = TempDataMCU;
      let dataArray = [];
      let maleAdd = 0;
      let femaleAdd = toCalculateFaultMCU;
      data.forEach((obj1, index) => {
        maleAdd += obj1.duration.value;
      });
      setBms_duration_three(maleAdd);
      let single_name_array = [];
      data.forEach((obj1, index) => {
        let male = (obj1.duration.value / maleAdd) * 100;
        let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
        dataArray.push({
          age: obj1.key.spnname.toUpperCase(),
          male: -male,
          female: female,
          orgLevalMale: obj1.duration.value.toFixed(0).toString(),
          orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
          signal_nm: obj1.key.spnname,
          signal_desc: obj1.key.Description,
          signal_val: obj1.key.spnvalue.toString(),
        });
        single_name_array.push(obj1.key.spnname);
      });
      //   setsingle_nameBCS1(single_name_array);
      for (let i = 0; i < dataArray.length; i++) {
        let count = 0;
        for (let j = i + 1; j < dataArray.length; j++) {
          if (dataArray[i].age === dataArray[j].age) {
            dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
            count = 1;
          }
        }
        if (count) {
          dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
        }
      }
      dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
      setDataMainMCU(dataArray);
    }

    if (toCalculateFaultVCU !== 0) {
      const data = TempDataVCU;
      let dataArray = [];
      let maleAdd = 0;
      let femaleAdd = toCalculateFaultVCU;
      data.forEach((obj1, index) => {
        maleAdd += obj1.duration.value;
      });
      setBms_duration_four(maleAdd);
      let single_name_array = [];
      data.forEach((obj1, index) => {
        let male = (obj1.duration.value / maleAdd) * 100;
        let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
        dataArray.push({
          age: obj1.key.spnname.toUpperCase(),
          male: -male,
          female: female,
          orgLevalMale: obj1.duration.value.toFixed(0).toString(),
          orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
          signal_nm: obj1.key.spnname,
          signal_desc: obj1.key.Description,
          signal_val: obj1.key.spnvalue.toString(),
        });
        single_name_array.push(obj1.key.spnname);
      });
      //   setsingle_nameBCS1(single_name_array);
      for (let i = 0; i < dataArray.length; i++) {
        let count = 0;
        for (let j = i + 1; j < dataArray.length; j++) {
          if (dataArray[i].age === dataArray[j].age) {
            dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
            count = 1;
          }
        }
        if (count) {
          dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
        }
      }
      dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
      setDataMainVCU(dataArray);
    }
  }, [
    toCalculateFaultBCS1,
    toCalculateFaultBCS2,
    toCalculateFaultMCU,
    toCalculateFaultVCU,
  ]);

  // const renderTabContent = (tabId) => {
  //     return (
  //         <div
  //         //   style={{
  //         //     width: 'auto',
  //         //     maxWidth: 'auto',
  //         //     overflowX: 'scroll',
  //         //     overflowY: 'scroll',
  //         //   }}
  //         >
  //           <div style={LineContainerBodyBD}>
  //             {isLoading ? (
  //               <ChartLoader />
  //             ) : dataMainBCS1.length > 0 ? (
  //               <COmpBiDirTest
  //                 dataMain={dataMainBCS1}
  //                 id={"BCS1"}
  //                 gloablfilter={gloablfilter}
  //                 signal_name={single_nameBCS1}
  //               />
  //             ) : (
  //               <NoData />
  //             )}
  //           </div>
  //         </div>
  //     );
  // };

  return (
    <div className="faultfirstpart">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div className="row mt-2">
        <div className="col-md-8">
          <span
            className="text-left"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#002060",
              paddingLeft: "30px",
            }}
          >
            Faults Observed in Field :{" "}
          </span>
          <span
            className="text-right"
            style={{ color: "#002060", fontSize: "12px" }}
          >
            {props.startdate} - {props.enddate}
          </span>
        </div>
      </div>

      <div className="row mt-3 ">
        <div className="col-md-1"></div>
        <div className="col-md-5">
          <div
            className="row"
            id="faultfirstparttitlebcs1"
            style={{ textAlign: "right" }}
          >
            <div className="col-md-4 text-start">
              <button className="btn" style={{ backgroundColor: "#d0d4d5" }}>
                BCS-1
              </button>
            </div>
            <div className="col-md-8 text-end">
              <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                <dt className="red_bus"></dt>
                <dd>Time Duration (mins)</dd>
                <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                <dd>Vehicle Count</dd>
              </dl>
            </div>
          </div>
          <div className="row pt-1">
            {/* {renderTabContent('BCS-1')} */}
            <div style={LineContainerBodyBD}>
              {isLoading ? (
                <ChartLoader />
              ) : dataMainBCS1.length > 0 ? (
                <div id="faultfirstpartbcs1">
                  <COmpBiDirTest
                    dataMain={dataMainBCS1}
                    id={"BCS1"}
                    gloablfilter={gloablfilter}
                    signal_name={single_nameBCS1}
                  />
                </div>
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>

        <div className="col-md-5">
          <div
            className="row"
            id="faultfirstparttitlebcs2"
            style={{ textAlign: "right" }}
          >
            <div className="col-md-4 text-start">
              <button className="btn" style={{ backgroundColor: "#d0d4d5" }}>
                BCS-2
              </button>
            </div>
            <div className="col-md-8 text-end">
              <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                <dt className="red_bus"></dt>
                <dd>Time Duration (mins)</dd>
                <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                <dd>Vehicle Count</dd>
              </dl>
            </div>
          </div>
          <div className="row pt-1">
            {/* {renderTabContent('BCS-1')} */}
            <div style={LineContainerBodyBD}>
              {isLoading ? (
                <ChartLoader />
              ) : dataMainBCS2.length > 0 ? (
                <div id="faultfirstpartbcs2">
                  <COmpBiDirTest
                    dataMain={dataMainBCS2}
                    id={"BCS2"}
                    gloablfilter={gloablfilter}
                    signal_name={single_nameBCS2}
                  />
                </div>
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-md-1"></div>
        <div className="col-md-5">
          <div
            className="row"
            id="faultfirstparttitlemcu"
            style={{ textAlign: "right" }}
          >
            <div className="col-md-4 text-start">
              <button className="btn" style={{ backgroundColor: "#d0d4d5" }}>
                MCU
              </button>
            </div>
            <div className="col-md-8 text-end">
              <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                <dt className="red_bus"></dt>
                <dd>Time Duration (mins)</dd>
                <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                <dd>Vehicle Count</dd>
              </dl>
            </div>
          </div>
          <div className="row pt-1">
            <div style={LineContainerBodyBD}>
              {isLoading ? (
                <ChartLoader />
              ) : dataMainMCU.length > 0 ? (
                <div id="faultfirstpartmcu">
                  <COmpBiDirTest
                    dataMain={dataMainMCU}
                    id={"MCU"}
                    gloablfilter={gloablfilter}
                    signal_name={single_nameMCU}
                  />
                </div>
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>

        <div className="col-md-5">
          <div
            className="row"
            id="faultfirstparttitlevcu"
            style={{ textAlign: "right" }}
          >
            <div className="col-md-4 text-start">
              <button className="btn" style={{ backgroundColor: "#d0d4d5" }}>
                VCU
              </button>
            </div>
            <div className="col-md-8 text-end">
              <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                <dt className="red_bus"></dt>
                <dd>Time Duration (mins)</dd>
                <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                <dd>Vehicle Count</dd>
              </dl>
            </div>
          </div>
          <div className="row pt-1">
            <div style={LineContainerBodyBD}>
              {isLoading ? (
                <ChartLoader />
              ) : dataMainMCU.length > 0 ? (
                <div id="faultfirstpartvcu">
                  <COmpBiDirTest
                    dataMain={dataMainVCU}
                    id={"VCU"}
                    gloablfilter={gloablfilter}
                    signal_name={single_nameVCU}
                  />
                </div>
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row bottomcontent pl-4" style={{ paddingTop: "155px" }}>
        <div className="col-md-3">
          <img
            src="../../../assets/img_Bus/Pdf_Page/footer.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-4">
          <p
            style={{
              fontSize: "11px",
              paddingTop: "60px",
              paddingLeft: "10px",
            }}
          >
            Copyright, Confidential, Tata Motors Limited
          </p>
        </div>
      </div>
    </div>
  );
});

export default FaultFirstPart;
